import React, { Component } from 'react';
import { EditorState } from 'draft-js';
import { Button, Link } from '../../../../../../../../../ui-kit';

import CommentTextEditor, { getContentState } from '../../../../CommentTextEditor';
import { getCurrentUserId } from '../../../../../../../../../common/utils';

import '../styles/_edit-reply.scss';



















class EditReply extends Component {
  static defaultProps = {
    visible: true
  };

  constructor(props) {
    super(props);

    this.state = {
      busy: false
    };
  }

  handleEditReply = async (e) => {
    e.stopPropagation();

    const {
      editReply,
      replyRef,
      comment,
      commentId,
      editorState,
      createdByUser,
      clearInput
    } = this.props;

    if (!commentId && !createdByUser) {
      return;
    }

    const { json, plainText } = getContentState(editorState);

    if (!plainText.trim()) {return;}

    this.setState({ busy: true });

    await editReply({
      commentId,
      input: { content: json },
      parentComment: comment
    });

    this.setState({ busy: false });

    clearInput();

    if (replyRef) {
      replyRef.scrollTo({ top: replyRef.scrollHeight, behavior: 'smooth' });
    }
  };

  render() {
    const {
      comment: { isResolved },
      visible,
      onUpdateContent,
      editorState,
      resourceOrganisationId,
      onInputFocus,
      clearInput
    } = this.props;

    const { busy } = this.state;

    const { plainText } = getContentState(editorState);

    const hasCurrentUserId = !!getCurrentUserId();

    return visible ?
    <>
        <div className="edit-reply">
          <CommentTextEditor
          placeholder="Enter reply"
          editorState={editorState}
          onUpdateContent={onUpdateContent}
          onSave={this.handleEditReply}
          disabled={isResolved}
          organisationId={resourceOrganisationId}
          onFocus={onInputFocus}
          setFocusOnMount={hasCurrentUserId} />

        </div>
        <div className="edit-reply__footer">
          <Link
          className="edit-reply__footer__cancel"
          button
          onClick={clearInput}>

            Cancel
          </Link>
          <Button
          onClick={this.handleEditReply}
          type="SECONDARY"
          busy={busy}
          disabled={!plainText.trim() || isResolved}>

            Save Changes
          </Button>
        </div>
      </> :
    null;
  }
}

export default EditReply;